import React from 'react'

import { useGetLatestUpdatedBooks } from '@hooks/latestUpdate/useGetLatestUpdatedBooks'
import { useAuthentication } from '@hooks/useAuthentication'
import { LatestUpdatePageProps, WithLatestUpdatePageProps } from './interface'

export function withLatestUpdatePage(
  Component: React.FC<LatestUpdatePageProps>
) {
  function WithLatestUpdatePage({ bookType }: WithLatestUpdatePageProps) {
    const { isUserLoading } = useAuthentication()
    const { data, isLoading, handleFetchNextPage } = useGetLatestUpdatedBooks({
      limitPerPage: 20,
      bookType,
    })

    const newProps = {
      data,
      handleFetchNextPage,
      bookType,
      isLoading: isLoading || isUserLoading,
    }

    return <Component {...newProps} />
  }
  return WithLatestUpdatePage
}
